import { HeaderUI } from './HeaderUI'
import { useHeader } from './useHeader'

export const HeaderComponent = () => {
  const props = useHeader()

  return <HeaderUI {...props} />
}
